import './utils/polyfill';

import * as Sentry from '@sentry/react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initSentry } from './analytics/init-sentry';
import './assets/styles/global.css';
import './assets/styles/style.scss';
import App from './components/App';
import config, { getLDConfig } from './config';
import { StrictMode } from 'react';

initSentry();

const rootElement = document.getElementById('root');
if (rootElement == null) {
  throw new Error('rootElement cannot be null');
}
const root = createRoot(rootElement);

const render = async () => {
  const ldConfig = await getLDConfig();

  const LDProvider = await asyncWithLDProvider({
    clientSideID: ldConfig.launchDarklyClientId,
    options: {
      streaming: config.environment === 'dev',
      logger: {
        debug() {},
        info() {},
        warn(...args) {
          console.warn(...args);
        },
        error(...args) {
          console.error(...args);
        },
      },
    },
    context: {
      kind: 'user',
      anonymous: true,
      webApp: 'bestill.rikstv.no',
    },
    timeout: 3,
  });

  root.render(
    <StrictMode>
      <LDProvider>
        <Sentry.ErrorBoundary fallback={<p>Noe gikk galt</p>}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Sentry.ErrorBoundary>
      </LDProvider>
    </StrictMode>,
  );
};

render();
